const RsvpCounts = ({yesCount, noCount, includeNos = true}) => {
    return (
    <div className="admin-rsvp-header">
        <div style={{display: "flex", alignItems: "center"}}>
            <i className="fa-solid fa-people-group event-icon"></i>
            <div className="event-admin-rsvp-title">RSVPs</div>
        </div>
        <span className="rsvp-count yes">✅ Yes: {yesCount}</span>
        {includeNos && <span className="rsvp-count no">❌ No: {noCount}</span>}
      </div>
    )
}

export default RsvpCounts;
